// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/light-long.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./img/dark.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./img/light-square.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./img/climbers.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./img/climbers-dark.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YRJZq__layout {
  height: 100%;
  --content-inset: 5%;
  background: var(--color-blue-3);
  overflow-x: hidden;
  overflow-y: auto;
  perspective: 2px;
  --phone-width: 4in;
  --section-gap: 5em;
  transition: background 300ms ease;
}

.YRJZq__layout section {
    transform-style: preserve-3d;
    position: relative;
  }

@media (prefers-color-scheme: dark) {

.rescueally:not(.rescueally-light) .YRJZq__layout {
    background: var(--color-blue-4);
}
  }

.rescueally.rescueally-dark .YRJZq__layout {
    background: var(--color-blue-4);
}

@media screen and (min-width: 1024px) {

.YRJZq__layout {
    display: flex;
    flex-direction: column;
}
  }

.YRJZq__layout * {
    transition: background 300ms ease;
  }

.YRJZq__layout button[role='presentation'] {
    transform: none !important;
  }

/* Hook Section: Splash image, heading card, intro, CTA */
.pvJ69__hookSection {
  position: relative;
  /* Trimmed (2026-08-24): the site links now occupy the space under the lede,
     so the hero no longer needs a long runway before the content starts.
     Measured nav-bottom → lifecycle-card-top on desktop: 469px → ~330px (-30%).
     Desktop needs its own value because .hookWrapper's lg block sets
     \`margin: 0 auto\`, zeroing the wrapper's bottom margin there — so on lg
     this rule is the ONLY one of the two that contributes. */
  margin-bottom: calc(1.4 * var(--section-gap));
}
@media screen and (min-width: 1024px) {
.pvJ69__hookSection {
    margin-bottom: calc(0.25 * var(--section-gap));
}
  }
.pvJ69__hookSection::before {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: translate3d(0, -30px, -1px) scale(1.51);
    background-repeat: no-repeat;
    top: -25vh;
    height: 130vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: top center;
    background-size: cover;
    box-shadow: inset 0 -20px 20px -10px var(--color-grey-5);
  }
@media (prefers-color-scheme: dark) {
.rescueally:not(.rescueally-light) .pvJ69__hookSection::before {
      top: -32vh;
      height: 140vh;
      background-position: 36% top;
      background-size: cover;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
      box-shadow: inset 0 -20px 20px -10px var(--color-grey-8);
  }
    }
.rescueally.rescueally-dark .pvJ69__hookSection::before {
      top: -32vh;
      height: 140vh;
      background-position: 36% top;
      background-size: cover;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
      box-shadow: inset 0 -20px 20px -10px var(--color-grey-8);
  }
@media screen and (min-width: 1024px) {
.pvJ69__hookSection::before {
      top: 0;
      height: 200vh;
      background-size: cover;
      background-position: center top;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
    }

@media screen and (min-width: 640px) {
    @media (prefers-color-scheme: dark) {
  .rescueally:not(.rescueally-light) .pvJ69__hookSection::before {
      top: -38vh;
      height: 160vh;
      background-size: cover;
      background-position: 45% top;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
    }
  .rescueally.rescueally-dark .pvJ69__hookSection::before {
      top: -38vh;
      height: 160vh;
      background-size: cover;
      background-position: 45% top;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}

@media screen and (min-width: 1024px) {
    @media (prefers-color-scheme: dark) {
  .rescueally:not(.rescueally-light) .pvJ69__hookSection::before {
      top: -38vh;
      height: 180vh;
      background-size: cover;
      background-position: center top;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
    }
  .rescueally.rescueally-dark .pvJ69__hookSection::before {
      top: -38vh;
      height: 180vh;
      background-size: cover;
      background-position: center top;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}

.mUyOV__hookWrapper {
  display: flex;
  flex-direction: column;
  padding-top: 35vh;
  margin-bottom: var(--section-gap);
}

@media screen and (min-width: 1024px) {

.mUyOV__hookWrapper {
    flex-direction: row;
    max-width: -webkit-fit-content;
    max-width: fit-content;
    margin: 0 auto;
    gap: 1vw;
    padding-top: 60vh;
}
  }

.cVIDW__hookLeft {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1em;
  perspective: 2px;
}

@media screen and (min-width: 1024px) {

.cVIDW__hookLeft {
    display: flex;
    width: 40em;
}
  }

.V9K2g__logo {
  width: 13em;
  margin-bottom: 1.5em;
  border-radius: 50%;
}

@media screen and (min-width: 1024px) {

.V9K2g__logo {
    position: absolute;
    width: 18em;
    top: -20em;
    right: -1em;
    z-index: 10;
    margin: 0;
}
  }

.FmOa___headingCard {
  position: relative;
  top: 3.5em;
  max-width: min(100%, 20em);
  padding-bottom: 0.5em;
  --card-compact-padding-y: 0.8em;
  --card-compact-padding-x: 1.3em;
  transform: translateZ(-1px) scale(1.5);
  margin-bottom: -0.5em;
}

.FmOa___headingCard .wild-card-header {
    padding-bottom: 0.5em !important;
  }

@media screen and (min-width: 1024px) {

.FmOa___headingCard {
    max-width: 100%;
    top: -16em;
    left: 5em;
    padding-left: 2em;
    padding-bottom: 0;
    margin-bottom: 0;
    --card-compact-padding-y: 1em;
    --card-compact-padding-x: 1.3em;
}
  }

.FmOa___headingCard h1 {
    font-size: 2em;
    font-weight: 600;
    margin: 0 0 0.1em;
    margin-left: em;
    text-transform: uppercase;
  }

@media screen and (min-width: 1024px) {

.FmOa___headingCard h1 {
      margin-left: 0;
      font-size: 3em;
  }
    }

.FmOa___headingCard h1 span:first-child {
    }

/* old + styles
    & span:nth-child(2) {
      font-weight: 900;
      color: var(--color-red-1);
      font-size: 1.5em;
      height: 0;
      display: inline-block;
      margin-top: -1em;
      transform: translateY(0.1em);
    } */

.FmOa___headingCard h1 span:last-child {
    }

.FmOa___headingCard .GvCTl__presents {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.8em;
    opacity: 0.6;
    margin: -0.3em 0;
  }

.FmOa___headingCard .TZbwC__headingCardInner {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

.FmOa___headingCard .H5gQ3__plus {
    background: white;
    border-radius: 50%;
    aspect-ratio: 1;
  }

.FmOa___headingCard .H5gQ3__plus svg {
      font-size: 2em;
      display: block;
      color: #ff3838;
      width: auto;
      transform: scale(1.1);
    }

.KEyRr__tagLine {
  display: flex;
  align-items: center;
  gap: 0.5em;
}

.KMv17__lead {
  font-family: var(--heading-font);
  font-size: 1.5em;
  font-weight: 800;
  text-transform: uppercase;
}

.KMv17__lead strong {
    display: block;
  }

.w_3pB__hookRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1em;
}

@media screen and (min-width: 1024px) {

.w_3pB__hookRight {
    align-items: flex-start;
}
  }

@media screen and (min-width: 1024px) {
  width: 25%;
  min-width: 10em;
  overflow: visible;
}

.cF4D0__hookPhoneWrapper {
  position: relative;
  z-index: 10;
  width: var(--phone-width);
  max-width: 100%;
}

@media screen and (min-width: 1024px) {

.cF4D0__hookPhoneWrapper {
    /* height: 0; */
    top: -5em;
}
  }

.f5w7a__phone {
  max-width: var(--phone-width);
}

.qguw8__screenshot {
  width: 100%;
}

.g6Lyo__descriptionCard {
  --card-compact-padding-y: 1.5em;
  --card-compact-padding-x: 1.7em;
  position: relative;
  margin: 0 -1em;
  padding: 0 1em;
}

.g6Lyo__descriptionCard strong {
    font-size: 1.1em;
  }

@media (min-width: 40rem) {

.g6Lyo__descriptionCard {
    max-width: -webkit-fit-content;
    max-width: fit-content;
    margin: 0 auto;
    padding: 0;
}
  }

@media screen and (min-width: 1024px) {

.g6Lyo__descriptionCard {
    --card-compact-padding-y: 2em;
    --card-compact-padding-x: 3em;
    margin-left: -2em;
    width: calc(100% + 30em);
    max-width: none;
}
  }

.kwmC8__cta {
  font-size: 1.2em;
  width: 100%;
  justify-content: center;
}

@media screen and (min-width: 1024px) {

.kwmC8__cta {
    font-size: 1.3em;
}
  }

.e6PLB__problemStatementCta {
  margin-top: 1.2em;
}

.GI2ls__appName {
  font-weight: bold !important;
  text-transform: uppercase;
  color: var(--color-red-0);
}

.xoM7Q__descriptionInner {
  max-width: 37em;
}

/* ====== Begin Content Sections ====== */
.xQTux__content {
  position: relative;
  background: linear-gradient(
    var(--color-blue-3),
    var(--color-blue-3) 30%,
    var(--color-blue-4) 90%,
    black
  );
}
@media (prefers-color-scheme: dark) {
.rescueally:not(.rescueally-light) .xQTux__content {
    background: linear-gradient(var(--color-blue-4), var(--color-blue-4) 30%, black);
}
  }
.rescueally.rescueally-dark .xQTux__content {
    background: linear-gradient(var(--color-blue-4), var(--color-blue-4) 30%, black);
}
@media screen and (min-width: 430px) {
.xQTux__content {
    /* This compensates for the transform on the contentRow0 */
    margin-top: calc(3 * var(--section-gap));
}
  }
@media screen and (min-width: 1024px) {
.xQTux__content {
    box-shadow: 0 -10px 20px 0 rgba(0, 0, 0, 0.4);
}
  }
@media screen and (min-width: 1024px) {
.xQTux__content {
    /* This compensates for the transform on the contentRow0 */
    margin-top: calc(2 * var(--section-gap));
}
  }
.xQTux__content h2 {
    font-size: 3em;
    /* text-decoration: underline; */
    text-underline-offset: 0.45em;
  }

.cSXSV__contentRow {
  display: flex;
  gap: 1vw;
}

/* >>>>>>>> Lifecycle Card <<<<<<<< */
.eDm5p__lifecycleCardRow {
  justify-content: center;
  margin-bottom: var(--section-gap);
}
@media screen and (min-width: 430px) {
.eDm5p__lifecycleCardRow {
    transform: translateY(-50%);
    margin-bottom: calc(-1 * var(--section-gap));
}
  }

.udcos__lifecycleCard {
  max-width: calc(100% + 4em);
  padding-top: 0.2em;
  --card-compact-padding-x: 2.7em;
  --card-compact-padding-y: 1.5em;
  --card-border-radius: 30px;

  position: relative;
  margin: 0 -1em;
  padding: 0 1em;
}

@media (prefers-color-scheme: dark) {

.rescueally:not(.rescueally-light) .udcos__lifecycleCard {
    background: var(--color-grey-7) !important;
}
  }

.rescueally.rescueally-dark .udcos__lifecycleCard {
    background: var(--color-grey-7) !important;
}

@media (min-width: 40rem) {

.udcos__lifecycleCard {
    --card-compact-padding-x: 0.5em;
    padding-top: 0;
}
  }

.udcos__lifecycleCard > .wild-card-content > .wild-card-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

@media screen and (min-width: 430px) {

.udcos__lifecycleCard > .wild-card-content > .wild-card-body {
      align-items: center;
      text-align: center;
  }
    }

@media screen and (min-width: 430px) {

.udcos__lifecycleCard > .wild-card-content .wild-card-heading {
      justify-content: center;
  }
    }

.udcos__lifecycleCard strong {
    font-weight: bold;
  }

.udcos__lifecycleCard p {
    max-width: 34em;
  }

.bjtws__lifecycleRow {
  display: flex;
  align-self: center;
  gap: 1em;
  padding: 1em;
  padding-top: 0;
  max-width: 100vw;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.bjtws__lifecycleRow::-webkit-scrollbar {
    display: none;
  }

.kakbq__lifecycleItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 5em;
  text-align: center;
  color: black;
  gap: 0.5em;
  border: 1px solid white;
  border-radius: 16px;
  padding: 1em 2em;
  aspect-ratio: 1;
  background: var(--color-grey-3);
}

.kakbq__lifecycleItem span {
    font-size: 0.7em;
    font-weight: bold;
  }

.kBNMr__offlineFirst {
  margin: 0.8em -0.3em 0.3em;
  font-weight: bold;
  --card-compact-padding-x: 1em;
  --card-compact-padding-y: 1em;
  text-align: center;
}

@media screen and (min-width: 1024px) {

.kBNMr__offlineFirst {
    --card-compact-padding-x: 1.3em;
    --card-compact-padding-y: 1.3em;
    margin: 0.8em 0 0;
}
  }

.kBNMr__offlineFirst svg {
    margin-right: -0.3em;
  }

.kBNMr__offlineFirst strong,.kBNMr__offlineFirst span {
    white-space: nowrap;
  }

/* >>>>>>>> Problem Statement Section <<<<<<<< */
/* >>>>>>>> Scribe launch (2.0) <<<<<<<< */
.lqSdi__scribeSection {
  color: white;
  padding: 0 var(--content-inset);
  margin: calc(1.5 * var(--section-gap)) auto var(--section-gap);
  max-width: 68em;
  font-weight: 300;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2em;
}
@media screen and (min-width: 430px) {
.lqSdi__scribeSection {
    /* The lifecycle card translates up over this row on small screens; take
       its offset back so the badge doesn't collide with the card's shadow. */
    margin-top: 0;
}
  }
/* Two-column only on LARGE screens: the copy's min-content (~500px with the
     one-line emphasis rule) plus the fixed-width phone overflow every width
     below ~860px — --screen-sm (430px!) put Pro-Max phones in row layout with
     390px of horizontal overflow. */
@media screen and (min-width: 1024px) {
.lqSdi__scribeSection {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 3em;
}
  }

.wYmHt__scribeCopy {
  text-align: center;
}

.wYmHt__scribeCopy h2 {
    line-height: 1.1;
    margin: 0.4em 0 0.5em;
  }

.wYmHt__scribeCopy p {
    margin: 0 0 1.2em;
    max-width: 32em;
  }

@media screen and (min-width: 1024px) {

.wYmHt__scribeCopy {
    text-align: left;
    flex: 1 1 auto;
}
  }

.cT89j__scribeBadge {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.35em 0.9em;
  border: 1px solid var(--color-red-2);
  border-radius: 2em;
  font-size: 0.8em;
  font-weight: bold;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* The rule under the phrase is a ONE-LINE device: an inline border that
     wraps splits into a full-width rule plus a stub under the orphan, which
     reads as a mistake. So the underline and the nowrap that guarantees one
     line live together, and on a phone (where the h2 is large enough that
     nowrap would clip off the right edge) the phrase simply wraps, unruled. */

@media screen and (min-width: 1024px) {

.AnkeM__scribeEmphasis {
    padding-bottom: 0.15em;
    border-bottom: 1px solid var(--color-red-2);
    line-height: 1.8;
    white-space: nowrap;
}
  }

.aOCkr__scribeLink {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.55em 1.4em;
  border: 1px solid var(--color-red-2);
  border-radius: 2em;
  color: white !important;
  font-weight: bold;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  transition: background-color 120ms ease;
}

.aOCkr__scribeLink:hover,.aOCkr__scribeLink:focus-visible {
    background-color: var(--color-red-2);
  }

.G4y2h__scribeStores {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.4em 0.8em;
  margin-top: 1.1em;
}

@media screen and (min-width: 1024px) {

.G4y2h__scribeStores {
    justify-content: flex-start;
}
  }

._1cSHb__scribeStoresLabel {
  font-size: 0.9em;
  opacity: 0.8;
}

.qGP87__scribeStoreButtons {
  /* The store badges carry their own sizing; this only keeps them on the
     same baseline as the "Or get the app:" label. */
  display: flex;
  align-items: center;
  gap: 0.5em;
}

.fz9gH__scribePhoneWrapper {
  display: flex;
  justify-content: center;
  flex: 0 0 auto;
}

.BzJHf__scribePhone {
  --phone-width: 2.4in;
}

@media screen and (min-width: 1024px) {

.BzJHf__scribePhone {
    --phone-width: 2.8in;
}
  }

.p1Bql__problemStatement {
  color: white;
  padding: 0 var(--content-inset);
  margin: calc(1.5 * var(--section-gap)) auto;
  font-weight: 300;
  max-width: 60em;
}

@media screen and (min-width: 430px) {

.p1Bql__problemStatement {
    margin-top: 0;
}
  }

.p1Bql__problemStatement h2 {
    line-height: 1.1;
    margin-bottom: 0.3em;
  }

.p1Bql__problemStatement h2 span {
      white-space: nowrap;
    }

.p1Bql__problemStatement p:first-child {
    margin-bottom: 1.2em;
  }

.p1Bql__problemStatement p:first-child span {
      padding-bottom: 0.15em;
      border-bottom: 1px solid var(--color-red-2);
      line-height: 1.8;
    }

.p1Bql__problemStatement strong {
    font-weight: bold;
  }

.p1Bql__problemStatement a {
    color: white !important;
    font-weight: bold;
    text-underline-offset: 0.3em !important;
  }

.BbUEP__carousel {
  height: 100vh;
  height: 101dvh;
  --phone-width: 3.5in;
}

.BbUEP__carousel h2 {
    font-size: 1.7em;
    font-weight: 300;
    font-family: var(--heading-font);
    text-align: center;
    margin-bottom: 1em;
  }

@media screen and (min-width: 430px) {

.BbUEP__carousel h2 {
      text-align: left;
  }
    }

/* Carousel 1 */

.poDAw__headToToe_annotation1 {
  top: -1em;
  left: auto;
  right: -1em;
  width: 50%;
}

@media screen and (min-width: 640px) {

.poDAw__headToToe_annotation1 {
    top: 3em;
    bottom: auto;
    right: auto;
}
  }

.IBCR3__headToToe_annotation2 {
  position: absolute;
  bottom: 2em;
  top: auto;
  left: auto;
  right: -1em;
  width: 50%;
}

@media screen and (min-width: 640px) {

.IBCR3__headToToe_annotation2 {
    left: 0;
    top: 74%;
    bottom: auto;
}
  }

.rkd_T__realtime_annotation1 {
  position: absolute;
  bottom: -2em;
  top: auto;
  left: auto;
  right: -2em;
  width: 55%;
}

@media screen and (min-width: 640px) {

.rkd_T__realtime_annotation1 {
    right: 0;
    left: auto;
    top: 37%;
    bottom: auto;
}
  }

.u16PE__outline_annotation1 {
  position: absolute;
  top: 4em;
  bottom: auto;
  left: auto;
  right: -1em;
  width: 55%;
}

@media screen and (min-width: 640px) {

.u16PE__outline_annotation1 {
    right: 0;
    left: auto;
    top: 40%;
}
  }

.ILpi3__messages_annotation1 {
  position: absolute;
  top: -1em;
  bottom: auto;
  left: auto;
  right: 0;
  width: 70%;
}

@media screen and (min-width: 430px) {

.ILpi3__messages_annotation1 {
    right: -1em;
}
  }

@media screen and (min-width: 640px) {

.ILpi3__messages_annotation1 {
    right: 0;
    left: auto;
    top: 12%;
    bottom: auto;
}
  }

.LX9v5__messages_annotation2 {
  position: absolute;
  top: auto;
  bottom: 0;
  left: auto;
  right: 0;
  width: 55%;
}

@media screen and (min-width: 430px) {

.LX9v5__messages_annotation2 {
    right: -1em;
}
  }

@media screen and (min-width: 640px) {

.LX9v5__messages_annotation2 {
    right: 0;
    left: auto;
    top: auto;
    bottom: 12%;
}
  }

.h_ADd__spanish_annotation1 {
  position: absolute;
  top: auto;
  left: auto;
  right: 0;
  bottom: 2.5em;
  width: 60%;
}

@media screen and (min-width: 430px) {

.h_ADd__spanish_annotation1 {
    right: -1em;
}
  }

@media screen and (min-width: 640px) {

.h_ADd__spanish_annotation1 {
    right: 0;
    left: auto;
    top: 41%;
    bottom: auto;
}
  }

.KtIZN__trustStatement {
  color: white;
  font-weight: 400;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-position: 35% center;
  padding: var(--section-gap) 0;
}

@media (prefers-color-scheme: dark) {

.rescueally:not(.rescueally-light) .KtIZN__trustStatement {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: 35% center;
}
  }

.rescueally.rescueally-dark .KtIZN__trustStatement {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: 35% center;
}

.KtIZN__trustStatement h2 {
    line-height: 1.1;
    margin-bottom: 0.5em;
  }

.KtIZN__trustStatement .Au0Ui__trustStatementInner {
    position: relative;
    padding: 1.5em 2em;
    margin: calc(1.5 * var(--section-gap)) auto;
    max-width: 960px;
  }

.KtIZN__trustStatement .Au0Ui__trustStatementInner::before {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: var(--color-blue-4);
      opacity: 0.6;
      z-index: -1;
    }

@media (min-width: 960px) {

.KtIZN__trustStatement .Au0Ui__trustStatementInner::before {
        border-radius: 16px;
    }
      }

@media (min-width: 960px) {

.KtIZN__trustStatement .Au0Ui__trustStatementInner {
      padding: 1em 2em;
  }
    }

@media screen and (min-width: 430px) {

.KtIZN__trustStatement {
    margin-top: 0;
}
  }

.KtIZN__trustStatement strong {
    font-weight: bold;
  }

/* Carousel 2 */

.fFu9K__guide_annotation1 {
  position: absolute;
  top: auto;
  bottom: 1em;
  right: -1em;
  left: auto;
  width: 70%;
}

@media screen and (min-width: 640px) {

.fFu9K__guide_annotation1 {
    left: 0;
    right: 0;
    top: 32%;
    bottom: auto;
}
  }

.m8YkH__vitalsHistory_annotation1,
.sZ1Li__guide2_annotation1 {
  position: absolute;
  top: -1em;
  left: auto;
  right: 0;
  width: 59%;
}

@media screen and (min-width: 640px) {

.m8YkH__vitalsHistory_annotation1,
.sZ1Li__guide2_annotation1 {
    right: 0;
    top: 2em;
    left: auto;
    bottom: auto;
}
  }

.j9zR4__vitalsHistory_annotation2,
.erAiE__guide2_annotation2 {
  position: absolute;
  right: 0;
  left: auto;
  top: auto;
  bottom: -2em;
  width: 59%;
}

@media screen and (min-width: 640px) {

.j9zR4__vitalsHistory_annotation2,
.erAiE__guide2_annotation2 {
    right: 0;
    top: auto;
    bottom: 1em;
}
  }

.Jhpy7__appToApp_annotation1 {
  position: absolute;
  top: auto;
  bottom: -2em;
  left: auto;
  right: 0;
  width: 80%;
}

@media screen and (min-width: 640px) {

.Jhpy7__appToApp_annotation1 {
    left: auto;
    right: 0;
    top: 25%;
    bottom: auto;
}
  }

.GU64z__pdf_annotation1 {
  position: absolute;
  top: auto;
  bottom: -2em;
  left: auto;
  right: 0;
  width: 80%;
}

@media screen and (min-width: 640px) {

.GU64z__pdf_annotation1 {
    left: auto;
    right: 0;
    top: 55%;
    bottom: auto;
}
  }

/* at the end so that it overrides */
@media screen and (min-width: 640px) {
.JN2c9__annotation {
    width: 175%;
}
  }
.JN2c9__annotation a {
    font-weight: bold;
    -webkit-text-decoration: underline !important;
    text-decoration: underline !important;
    text-underline-offset: 0.2em !important;
  }
@media screen and (min-width: 640px) {
.JN2c9__annotation .wild-card-heading {
      max-width: calc(38% + (490px - 50vh));
  }
    }
@media screen and (min-width: 640px) {
.JN2c9__annotation .wild-card-body > div {
      max-width: calc(38% + (490px - 50vh));
  }
    }

/* >>>>>>>> END CAROUSELS <<<<<<< */

.y0I_s__lightDarkModeCard {
  max-width: min(100% - 2 * var(--content-inset), 24em);
  margin: var(--section-gap) auto;
  text-align: center;
  padding-right: 2em;
}

.y0I_s__lightDarkModeCard button {
    margin: 1em 0;
  }

.cybMS__link {
  -webkit-text-decoration: underline !important;
  text-decoration: underline !important;
  text-underline-offset: 3px;
}

.pkgBz__nowrap {
  white-space: nowrap;
}

.roE8E__footerNav {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.1em;
  max-width: 100%;
  flex-wrap: wrap;
}

.roE8E__footerNav a {
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    padding: 0 1em;
    margin-right: -1px;
    margin-bottom: 1em;
  }

/* Desktop hero nav: the site links, tucked into the empty space beneath the
   description card. Width comes from .hookLeft (40em), NOT from the card,
   which overflows its column on purpose — so footerNav's flex-wrap gives the
   two-or-three centred rows this space wants. */
.Vs7Od__heroNav {
  position: relative;
  z-index: 1;
  margin-top: 2.5em;
  width: 100%;
  font-size: 1em;

  /* In its old spot at the foot of the hero these links sat on the darkened
     bottom edge of the photo; here they land on open sky, which is bright in
     the light-scheme image. A soft shadow keeps them legible against both
     without changing the treatment. */
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);
  /* Inherited 200 (Manrope ExtraLight) is too fine to hold up over a photo. */
  font-weight: 400;
}
.Vs7Od__heroNav a {
    border-color: rgba(255, 255, 255, 0.65);
  }

.kx38v__headerNav {
  margin-top: 2em;
  padding: 0 var(--content-inset);
  position: relative;
  z-index: 1;
}

@media screen and (min-width: 1024px) {

.kx38v__headerNav {
    margin-top: calc(-2em);
}
  }

.xQTux__content .tp8ti__copyright {
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.8em;
  }

.xQTux__content footer {
    padding: 4em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
  }

/* Store badges flanking the hero logo on portrait screens — one on each side,
   vertically centered on the logo. Icons scale with font-size (2.4em in
   GetTheAppCTA). Hidden in the wide/landscape layout, where the description
   card's CTA box carries the store links instead. */
._C1qO__logoWrapper {
  position: relative;

  /* In the landscape layout the logo itself is position:absolute and must
     anchor to the section, not this wrapper — keep the wrapper static there. */
}
@media screen and (min-width: 1024px) {
._C1qO__logoWrapper {
    position: static;
}
  }

.gPaS4__heroStores {
  position: absolute;
  top: auto;
  /* align with the bottom of the logo image: the logo carries 1.5em
     (wrapper-em) bottom margin inside the wrapper → 1.5 / 1.35 local em */
  bottom: 1.11em;
  left: 50%;
  transform: translateX(-50%);
  /* logo is 13em (wrapper-em) wide; row = logo + ~2.5em breathing per side.
     Our font-size is 1.35em, so wrapper-18em ≈ 13.4 local em. */
  width: 15.7em;
  display: flex;
  align-items: flex-end;
  margin: 0;
  font-size: 1.35em;
  pointer-events: none;
}

.gPaS4__heroStores > span {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0;
  }

.gPaS4__heroStores > span a {
      pointer-events: auto;
    }

@media screen and (min-width: 1024px) {

.gPaS4__heroStores {
    display: none;
}
  }

/* Translucent hero box housing the store CTA inside the description card. */
.yYi0M__ctaHeroBox {
  margin-top: 1em;
  padding: 1em 1.4em;
  border-radius: 14px;
  background: color-mix(in srgb, var(--color-paper-2) 40%, transparent);
  border: none;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/routes/home/HomeRoute.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AAuBnC;;AArBE;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;AAEA;;AAhBF;IAiBI,+BAA+B;AAenC;EAdE;;AAlBF;IAiBI,+BAA+B;AAenC;;AAZE;;AApBF;IAqBI,aAAa;IACb,sBAAsB;AAU1B;EATE;;AAEA;IACE,iCAAiC;EACnC;;AAEA;IACE,0BAA0B;EAC5B;;AAGF,yDAAyD;AACzD;EACE,kBAAkB;EAClB;;;;;6DAK2D;EAC3D,6CAA6C;AAuC/C;AArCE;AAVF;IAWI,8CAA8C;AAoClD;EAnCE;AAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kDAAkD;IAClD,4BAA4B;IAC5B,UAAU;IACV,aAAa;IACb,yDAA4C;IAC5C,+BAA+B;IAC/B,sBAAsB;IACtB,wDAAwD;EAkB1D;AAhBE;AAhBF;MAiBI,UAAU;MACV,aAAa;MACb,4BAA4B;MAC5B,sBAAsB;MACtB,yDAAsC;MACtC,wDAAwD;EAU5D;IATE;AAvBF;MAiBI,UAAU;MACV,aAAa;MACb,4BAA4B;MAC5B,sBAAsB;MACtB,yDAAsC;MACtC,wDAAwD;EAU5D;AAPE;AAzBF;MA0BI,MAAM;MACN,aAAa;MACb,sBAAsB;MACtB,+BAA+B;MAC/B,yDAA8C;EAElD;IADE;;AAIJ;IAEI;EADF;MAEI,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,4BAA4B;MAC5B,yDAAsC;EAE1C;IADE;EAPF;MAEI,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,4BAA4B;MAC5B,yDAAsC;EAE1C;AACF;;AAEA;IAEI;EADF;MAEI,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,+BAA+B;MAC/B,yDAAsC;EAE1C;IADE;EAPF;MAEI,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,+BAA+B;MAC/B,yDAAsC;EAE1C;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;AASnC;;AAPE;;AANF;IAOI,mBAAmB;IACnB,8BAAsB;IAAtB,sBAAsB;IACtB,cAAc;IACd,QAAQ;IACR,iBAAiB;AAErB;EADE;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAMlB;;AAJE;;AARF;IASI,aAAa;IACb,WAAW;AAEf;EADE;;AAGF;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AAUpB;;AARE;;AALF;IAMI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,SAAS;AAEb;EADE;;AAGF;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,qBAAqB;AA2EvB;;AAzEE;IACE,gCAAgC;EAClC;;AAEA;;AAdF;IAeI,eAAe;IACf,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,+BAA+B;AA6DnC;EA5DE;;AAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAuB3B;;AArBE;;AAPF;MAQI,cAAc;MACd,cAAc;EAmBlB;IAlBE;;AAEA;IACA;;AAEA;;;;;;;;;OASG;;AAEH;IACA;;AAGF;IACE,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;EACZ;;AAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EASjB;;AAPE;MACE,cAAc;MACd,cAAc;MACd,cAAc;MACd,WAAW;MACX,qBAAqB;IACvB;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAI3B;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAKhB;;AAHE;;AANF;IAOI,uBAAuB;AAE3B;EADE;;AAGF;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;AAMjB;;AAJE;;AANF;IAOI,eAAe;IACf,SAAS;AAEb;EADE;;AAGF;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAmBhB;;AAjBE;IACE,gBAAgB;EAClB;;AAEA;;AAXF;IAYI,8BAAsB;IAAtB,sBAAsB;IACtB,cAAc;IACd,UAAU;AAUd;EATE;;AAEA;;AAjBF;IAkBI,6BAA6B;IAC7B,6BAA6B;IAC7B,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;AAEnB;EADE;;AAGF;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AAKzB;;AAHE;;AALF;IAMI,gBAAgB;AAEpB;EADE;;AAGF;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB;;;;;GAKC;AAwBH;AAtBE;AATF;IAUI,gFAAgF;AAqBpF;EApBE;AAXF;IAUI,gFAAgF;AAqBpF;AAlBE;AAbF;IAcI,0DAA0D;IAC1D,wCAAwC;AAgB5C;EAfE;AAEA;AAlBF;IAmBI,6CAA6C;AAYjD;EAXE;AACA;AArBF;IAsBI,0DAA0D;IAC1D,wCAAwC;AAQ5C;EAPE;AAEA;IACE,cAAc;IACd,gCAAgC;IAChC,6BAA6B;EAC/B;;AAGF;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,iCAAiC;AAMnC;AAJE;AAJF;IAKI,2BAA2B;IAC3B,4CAA4C;AAEhD;EADE;;AAGF;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;;EAE1B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAmChB;;AAjCE;;AAXF;IAYI,0CAA0C;AAgC9C;EA/BE;;AAbF;IAYI,0CAA0C;AAgC9C;;AA7BE;;AAfF;IAgBI,+BAA+B;IAC/B,cAAc;AA2BlB;EA1BE;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EAMzB;;AAJE;;AALF;MAMI,mBAAmB;MACnB,kBAAkB;EAEtB;IADE;;AAIA;;AADF;MAEI,uBAAuB;EAE3B;IADE;;AAGF;IACE,iBAAiB;EACnB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AAIvB;;AAHE;IACE,aAAa;EACf;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AAMjC;;AAJE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;AAGF;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;AAgBpB;;AAdE;;AAPF;IAQI,+BAA+B;IAC/B,+BAA+B;IAC/B,iBAAiB;AAWrB;EAVE;;AAEA;IACE,oBAAoB;EACtB;;AAEA;IAEE,mBAAmB;EACrB;;AAGF,gDAAgD;AAChD,0CAA0C;AAC1C;EACE,YAAY;EACZ,+BAA+B;EAC/B,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AAkBV;AAhBE;AAZF;IAaI;6EACyE;IACzE,aAAa;AAajB;EAZE;AAEA;;;oCAGkC;AAClC;AAtBF;IAuBI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AAEZ;EADE;;AAGF;EACE,kBAAkB;AAgBpB;;AAdE;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;AAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAEA;;AAbF;IAcI,gBAAgB;IAChB,cAAc;AAElB;EADE;;AAGF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAGE;;;;8EAI4E;;AAC5E;;AANF;IAOI,sBAAsB;IACtB,2CAA2C;IAC3C,gBAAgB;IAChB,mBAAmB;AAEvB;EADE;;AAGF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAgC;EAAhC,gCAAgC;EAChC,uCAAuC;AAMzC;;AAJE;IAEE,oCAAoC;EACtC;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AAKnB;;AAHE;;AARF;IASI,2BAA2B;AAE/B;EADE;;AAGF;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;oDACkD;EAClD,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AAKtB;;AAHE;;AAHF;IAII,oBAAoB;AAExB;EADE;;AAGF;EACE,YAAY;EACZ,+BAA+B;EAC/B,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;AAiCjB;;AA/BE;;AAPF;IAQI,aAAa;AA8BjB;EA7BE;;AAEA;IACE,gBAAgB;IAChB,oBAAoB;EAKtB;;AAHE;MACE,mBAAmB;IACrB;;AAGF;IACE,oBAAoB;EAMtB;;AALE;MACE,sBAAsB;MACtB,2CAA2C;MAC3C,gBAAgB;IAClB;;AAGF;IACE,iBAAiB;EACnB;;AAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,uCAAuC;EACzC;;AAGF;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AAatB;;AAXE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;EAKpB;;AAHE;;AAPF;MAQI,gBAAgB;EAEpB;IADE;;AAIJ,eAAe;;AAEf;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,UAAU;AAOZ;;AALE;;AANF;IAOI,QAAQ;IACR,YAAY;IACZ,WAAW;AAEf;EADE;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,UAAU;AAOZ;;AALE;;AARF;IASI,OAAO;IACP,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,UAAU;AAQZ;;AANE;;AARF;IASI,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU;AAOZ;;AALE;;AARF;IASI,QAAQ;IACR,UAAU;IACV,QAAQ;AAEZ;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,UAAU;AAYZ;;AAVE;;AARF;IASI,WAAW;AASf;EARE;;AAEA;;AAZF;IAaI,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,QAAQ;EACR,UAAU;AAYZ;;AAVE;;AARF;IASI,WAAW;AASf;EARE;;AAEA;;AAZF;IAaI,QAAQ;IACR,UAAU;IACV,SAAS;IACT,WAAW;AAEf;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,aAAa;EACb,UAAU;AAYZ;;AAVE;;AARF;IASI,WAAW;AASf;EARE;;AAEA;;AAZF;IAaI,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF;EACE,YAAY;EACZ,gBAAgB;EAChB,yDAA0C;EAC1C,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;AA8C/B;;AA5CE;;AARF;IASI,yDAA+C;IAC/C,+BAA+B;AA0CnC;EAzCE;;AAXF;IASI,yDAA+C;IAC/C,+BAA+B;AA0CnC;;AAvCE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;AAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;EAqBlB;;AApBE;MACE,cAAc;MACd,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,QAAQ;MACR,SAAS;MACT,+BAA+B;MAC/B,YAAY;MACZ,WAAW;IAKb;;AAHE;;AAZF;QAaI,mBAAmB;IAEvB;MADE;;AAGF;;AAtBF;MAuBI,gBAAgB;EAEpB;IADE;;AAGF;;AA7CF;IA8CI,aAAa;AAMjB;EALE;;AAEA;IACE,iBAAiB;EACnB;;AAGF,eAAe;;AAEf;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;AAQZ;;AANE;;AARF;IASI,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,UAAU;AAQZ;;AANE;;AARF;;IASI,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,YAAY;AAEhB;EADE;;AAGF;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;AAOZ;;AALE;;AATF;;IAUI,QAAQ;IACR,SAAS;IACT,WAAW;AAEf;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,UAAU;AAQZ;;AANE;;AARF;IASI,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,UAAU;AAQZ;;AANE;;AARF;IASI,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,YAAY;AAEhB;EADE;;AAGF,oCAAoC;AAElC;AADF;IAEI,WAAW;AAoBf;EAnBE;AAEA;IACE,iBAAiB;IACjB,6CAAqC;IAArC,qCAAqC;IACrC,uCAAuC;EACzC;AAGE;AADF;MAEI,qCAAqC;EAEzC;IADE;AAIA;AADF;MAEI,qCAAqC;EAEzC;IADE;;AAIJ,mCAAmC;;AAEnC;EACE,qDAAqD;EACrD,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AAKpB;;AAHE;IACE,aAAa;EACf;;AAGF;EACE,6CAAqC;EAArC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AASjB;;AAPE;IACE,gDAAgD;IAChD,+CAA+C;IAC/C,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;;;gDAGgD;AAChD;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,cAAc;;EAEd;;;sCAGoC;EACpC,0CAA0C;EAC1C,4EAA4E;EAC5E,gBAAgB;AAKlB;AAHE;IACE,uCAAuC;EACzC;;AAGF;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AAKZ;;AAHE;;AANF;IAOI,sBAAsB;AAE1B;EADE;;AAIA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;;AAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;AAGF;;;oDAGoD;AACpD;EACE,kBAAkB;;EAElB;+EAC6E;AAI/E;AAHE;AALF;IAMI,gBAAgB;AAEpB;EADE;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT;0EACwE;EACxE,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B;gEAC8D;EAC9D,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AAgBtB;;AAdE;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,UAAU;EAKZ;;AAHE;MACE,oBAAoB;IACtB;;AAGF;;AA5BF;IA6BI,aAAa;AAEjB;EADE;;AAGF,4EAA4E;AAC5E;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qEAAqE;EACrE,YAAY;EACZ,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".layout {\n  height: 100%;\n  --content-inset: 5%;\n  background: var(--color-blue-3);\n  overflow-x: hidden;\n  overflow-y: auto;\n  perspective: 2px;\n  --phone-width: 4in;\n  --section-gap: 5em;\n  transition: background 300ms ease;\n\n  & section {\n    transform-style: preserve-3d;\n    position: relative;\n  }\n\n  @media (prefers-color-scheme: dark) {\n    background: var(--color-blue-4);\n  }\n\n  @media (--screen-lg) {\n    display: flex;\n    flex-direction: column;\n  }\n\n  & * {\n    transition: background 300ms ease;\n  }\n\n  & button[role='presentation'] {\n    transform: none !important;\n  }\n}\n\n/* Hook Section: Splash image, heading card, intro, CTA */\n.hookSection {\n  position: relative;\n  /* Trimmed (2026-08-24): the site links now occupy the space under the lede,\n     so the hero no longer needs a long runway before the content starts.\n     Measured nav-bottom → lifecycle-card-top on desktop: 469px → ~330px (-30%).\n     Desktop needs its own value because .hookWrapper's lg block sets\n     `margin: 0 auto`, zeroing the wrapper's bottom margin there — so on lg\n     this rule is the ONLY one of the two that contributes. */\n  margin-bottom: calc(1.4 * var(--section-gap));\n\n  @media (--screen-lg) {\n    margin-bottom: calc(0.25 * var(--section-gap));\n  }\n\n  &::before {\n    display: block;\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    transform: translate3d(0, -30px, -1px) scale(1.51);\n    background-repeat: no-repeat;\n    top: -25vh;\n    height: 130vh;\n    background-image: url(./img/light-long.webp);\n    background-position: top center;\n    background-size: cover;\n    box-shadow: inset 0 -20px 20px -10px var(--color-grey-5);\n\n    @media (prefers-color-scheme: dark) {\n      top: -32vh;\n      height: 140vh;\n      background-position: 36% top;\n      background-size: cover;\n      background-image: url(./img/dark.webp);\n      box-shadow: inset 0 -20px 20px -10px var(--color-grey-8);\n    }\n\n    @media (--screen-lg) {\n      top: 0;\n      height: 200vh;\n      background-size: cover;\n      background-position: center top;\n      background-image: url(./img/light-square.webp);\n    }\n  }\n}\n\n@media (--screen-md) {\n  .hookSection::before {\n    @media (prefers-color-scheme: dark) {\n      top: -38vh;\n      height: 160vh;\n      background-size: cover;\n      background-position: 45% top;\n      background-image: url(./img/dark.webp);\n    }\n  }\n}\n\n@media (--screen-lg) {\n  .hookSection::before {\n    @media (prefers-color-scheme: dark) {\n      top: -38vh;\n      height: 180vh;\n      background-size: cover;\n      background-position: center top;\n      background-image: url(./img/dark.webp);\n    }\n  }\n}\n\n.hookWrapper {\n  display: flex;\n  flex-direction: column;\n  padding-top: 35vh;\n  margin-bottom: var(--section-gap);\n\n  @media (--screen-lg) {\n    flex-direction: row;\n    max-width: fit-content;\n    margin: 0 auto;\n    gap: 1vw;\n    padding-top: 60vh;\n  }\n}\n\n.hookLeft {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 1em;\n  perspective: 2px;\n\n  @media (--screen-lg) {\n    display: flex;\n    width: 40em;\n  }\n}\n\n.logo {\n  width: 13em;\n  margin-bottom: 1.5em;\n  border-radius: 50%;\n\n  @media (--screen-lg) {\n    position: absolute;\n    width: 18em;\n    top: -20em;\n    right: -1em;\n    z-index: 10;\n    margin: 0;\n  }\n}\n\n.headingCard {\n  position: relative;\n  top: 3.5em;\n  max-width: min(100%, 20em);\n  padding-bottom: 0.5em;\n  --card-compact-padding-y: 0.8em;\n  --card-compact-padding-x: 1.3em;\n  transform: translateZ(-1px) scale(1.5);\n  margin-bottom: -0.5em;\n\n  & :global(.wild-card-header) {\n    padding-bottom: 0.5em !important;\n  }\n\n  @media (--screen-lg) {\n    max-width: 100%;\n    top: -16em;\n    left: 5em;\n    padding-left: 2em;\n    padding-bottom: 0;\n    margin-bottom: 0;\n    --card-compact-padding-y: 1em;\n    --card-compact-padding-x: 1.3em;\n  }\n\n  & h1 {\n    font-size: 2em;\n    font-weight: 600;\n    margin: 0 0 0.1em;\n    margin-left: em;\n    text-transform: uppercase;\n\n    @media (--screen-lg) {\n      margin-left: 0;\n      font-size: 3em;\n    }\n\n    & span:first-child {\n    }\n\n    /* old + styles\n    & span:nth-child(2) {\n      font-weight: 900;\n      color: var(--color-red-1);\n      font-size: 1.5em;\n      height: 0;\n      display: inline-block;\n      margin-top: -1em;\n      transform: translateY(0.1em);\n    } */\n\n    & span:last-child {\n    }\n  }\n\n  & .presents {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 0.8em;\n    opacity: 0.6;\n    margin: -0.3em 0;\n  }\n\n  & .headingCardInner {\n    display: flex;\n    align-items: center;\n    gap: 0.5em;\n  }\n\n  & .plus {\n    background: white;\n    border-radius: 50%;\n    aspect-ratio: 1;\n\n    & svg {\n      font-size: 2em;\n      display: block;\n      color: #ff3838;\n      width: auto;\n      transform: scale(1.1);\n    }\n  }\n}\n\n.tagLine {\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n}\n\n.lead {\n  font-family: var(--heading-font);\n  font-size: 1.5em;\n  font-weight: 800;\n  text-transform: uppercase;\n  & strong {\n    display: block;\n  }\n}\n\n.hookRight {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 1em;\n\n  @media (--screen-lg) {\n    align-items: flex-start;\n  }\n}\n\n@media (--screen-lg) {\n  width: 25%;\n  min-width: 10em;\n  overflow: visible;\n}\n\n.hookPhoneWrapper {\n  position: relative;\n  z-index: 10;\n  width: var(--phone-width);\n  max-width: 100%;\n\n  @media (--screen-lg) {\n    /* height: 0; */\n    top: -5em;\n  }\n}\n\n.phone {\n  max-width: var(--phone-width);\n}\n\n.screenshot {\n  width: 100%;\n}\n\n.descriptionCard {\n  --card-compact-padding-y: 1.5em;\n  --card-compact-padding-x: 1.7em;\n  position: relative;\n  margin: 0 -1em;\n  padding: 0 1em;\n\n  & strong {\n    font-size: 1.1em;\n  }\n\n  @media (min-width: 40rem) {\n    max-width: fit-content;\n    margin: 0 auto;\n    padding: 0;\n  }\n\n  @media (--screen-lg) {\n    --card-compact-padding-y: 2em;\n    --card-compact-padding-x: 3em;\n    margin-left: -2em;\n    width: calc(100% + 30em);\n    max-width: none;\n  }\n}\n\n.cta {\n  font-size: 1.2em;\n  width: 100%;\n  justify-content: center;\n\n  @media (--screen-lg) {\n    font-size: 1.3em;\n  }\n}\n\n.problemStatementCta {\n  margin-top: 1.2em;\n}\n\n.appName {\n  font-weight: bold !important;\n  text-transform: uppercase;\n  color: var(--color-red-0);\n}\n\n.descriptionInner {\n  max-width: 37em;\n}\n\n/* ====== Begin Content Sections ====== */\n.content {\n  position: relative;\n  background: linear-gradient(\n    var(--color-blue-3),\n    var(--color-blue-3) 30%,\n    var(--color-blue-4) 90%,\n    black\n  );\n\n  @media (prefers-color-scheme: dark) {\n    background: linear-gradient(var(--color-blue-4), var(--color-blue-4) 30%, black);\n  }\n\n  @media (--screen-sm) {\n    /* This compensates for the transform on the contentRow0 */\n    margin-top: calc(3 * var(--section-gap));\n  }\n\n  @media (--screen-lg) {\n    box-shadow: 0 -10px 20px 0 rgba(0, 0, 0, 0.4);\n  }\n  @media (--screen-lg) {\n    /* This compensates for the transform on the contentRow0 */\n    margin-top: calc(2 * var(--section-gap));\n  }\n\n  & h2 {\n    font-size: 3em;\n    /* text-decoration: underline; */\n    text-underline-offset: 0.45em;\n  }\n}\n\n.contentRow {\n  display: flex;\n  gap: 1vw;\n}\n\n/* >>>>>>>> Lifecycle Card <<<<<<<< */\n.lifecycleCardRow {\n  justify-content: center;\n  margin-bottom: var(--section-gap);\n\n  @media (--screen-sm) {\n    transform: translateY(-50%);\n    margin-bottom: calc(-1 * var(--section-gap));\n  }\n}\n\n.lifecycleCard {\n  max-width: calc(100% + 4em);\n  padding-top: 0.2em;\n  --card-compact-padding-x: 2.7em;\n  --card-compact-padding-y: 1.5em;\n  --card-border-radius: 30px;\n\n  position: relative;\n  margin: 0 -1em;\n  padding: 0 1em;\n\n  @media (prefers-color-scheme: dark) {\n    background: var(--color-grey-7) !important;\n  }\n\n  @media (min-width: 40rem) {\n    --card-compact-padding-x: 0.5em;\n    padding-top: 0;\n  }\n\n  & > :global(.wild-card-content) > :global(.wild-card-body) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    @media (--screen-sm) {\n      align-items: center;\n      text-align: center;\n    }\n  }\n\n  & > :global(.wild-card-content) :global(.wild-card-heading) {\n    @media (--screen-sm) {\n      justify-content: center;\n    }\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n\n  & p {\n    max-width: 34em;\n  }\n}\n\n.lifecycleRow {\n  display: flex;\n  align-self: center;\n  gap: 1em;\n  padding: 1em;\n  padding-top: 0;\n  max-width: 100vw;\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.lifecycleItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 5em;\n  text-align: center;\n  color: black;\n  gap: 0.5em;\n  border: 1px solid white;\n  border-radius: 16px;\n  padding: 1em 2em;\n  aspect-ratio: 1;\n  background: var(--color-grey-3);\n\n  & span {\n    font-size: 0.7em;\n    font-weight: bold;\n  }\n}\n\n.offlineFirst {\n  margin: 0.8em -0.3em 0.3em;\n  font-weight: bold;\n  --card-compact-padding-x: 1em;\n  --card-compact-padding-y: 1em;\n  text-align: center;\n\n  @media (--screen-lg) {\n    --card-compact-padding-x: 1.3em;\n    --card-compact-padding-y: 1.3em;\n    margin: 0.8em 0 0;\n  }\n\n  & svg {\n    margin-right: -0.3em;\n  }\n\n  & strong,\n  & span {\n    white-space: nowrap;\n  }\n}\n\n/* >>>>>>>> Problem Statement Section <<<<<<<< */\n/* >>>>>>>> Scribe launch (2.0) <<<<<<<< */\n.scribeSection {\n  color: white;\n  padding: 0 var(--content-inset);\n  margin: calc(1.5 * var(--section-gap)) auto var(--section-gap);\n  max-width: 68em;\n  font-weight: 300;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2em;\n\n  @media (--screen-sm) {\n    /* The lifecycle card translates up over this row on small screens; take\n       its offset back so the badge doesn't collide with the card's shadow. */\n    margin-top: 0;\n  }\n\n  /* Two-column only on LARGE screens: the copy's min-content (~500px with the\n     one-line emphasis rule) plus the fixed-width phone overflow every width\n     below ~860px — --screen-sm (430px!) put Pro-Max phones in row layout with\n     390px of horizontal overflow. */\n  @media (--screen-lg) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 3em;\n  }\n}\n\n.scribeCopy {\n  text-align: center;\n\n  & h2 {\n    line-height: 1.1;\n    margin: 0.4em 0 0.5em;\n  }\n\n  & p {\n    margin: 0 0 1.2em;\n    max-width: 32em;\n  }\n\n  @media (--screen-lg) {\n    text-align: left;\n    flex: 1 1 auto;\n  }\n}\n\n.scribeBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  padding: 0.35em 0.9em;\n  border: 1px solid var(--color-red-2);\n  border-radius: 2em;\n  font-size: 0.8em;\n  font-weight: bold;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.scribeEmphasis {\n  /* The rule under the phrase is a ONE-LINE device: an inline border that\n     wraps splits into a full-width rule plus a stub under the orphan, which\n     reads as a mistake. So the underline and the nowrap that guarantees one\n     line live together, and on a phone (where the h2 is large enough that\n     nowrap would clip off the right edge) the phrase simply wraps, unruled. */\n  @media (--screen-lg) {\n    padding-bottom: 0.15em;\n    border-bottom: 1px solid var(--color-red-2);\n    line-height: 1.8;\n    white-space: nowrap;\n  }\n}\n\n.scribeLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  padding: 0.55em 1.4em;\n  border: 1px solid var(--color-red-2);\n  border-radius: 2em;\n  color: white !important;\n  font-weight: bold;\n  text-decoration: none !important;\n  transition: background-color 120ms ease;\n\n  &:hover,\n  &:focus-visible {\n    background-color: var(--color-red-2);\n  }\n}\n\n.scribeStores {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.4em 0.8em;\n  margin-top: 1.1em;\n\n  @media (--screen-lg) {\n    justify-content: flex-start;\n  }\n}\n\n.scribeStoresLabel {\n  font-size: 0.9em;\n  opacity: 0.8;\n}\n\n.scribeStoreButtons {\n  /* The store badges carry their own sizing; this only keeps them on the\n     same baseline as the \"Or get the app:\" label. */\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n}\n\n.scribePhoneWrapper {\n  display: flex;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.scribePhone {\n  --phone-width: 2.4in;\n\n  @media (--screen-lg) {\n    --phone-width: 2.8in;\n  }\n}\n\n.problemStatement {\n  color: white;\n  padding: 0 var(--content-inset);\n  margin: calc(1.5 * var(--section-gap)) auto;\n  font-weight: 300;\n  max-width: 60em;\n\n  @media (--screen-sm) {\n    margin-top: 0;\n  }\n\n  & h2 {\n    line-height: 1.1;\n    margin-bottom: 0.3em;\n\n    & span {\n      white-space: nowrap;\n    }\n  }\n\n  & p:first-child {\n    margin-bottom: 1.2em;\n    & span {\n      padding-bottom: 0.15em;\n      border-bottom: 1px solid var(--color-red-2);\n      line-height: 1.8;\n    }\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n\n  & a {\n    color: white !important;\n    font-weight: bold;\n    text-underline-offset: 0.3em !important;\n  }\n}\n\n.carousel {\n  height: 100vh;\n  height: 101dvh;\n  --phone-width: 3.5in;\n\n  & h2 {\n    font-size: 1.7em;\n    font-weight: 300;\n    font-family: var(--heading-font);\n    text-align: center;\n    margin-bottom: 1em;\n\n    @media (--screen-sm) {\n      text-align: left;\n    }\n  }\n}\n\n/* Carousel 1 */\n\n.headToToe_annotation1 {\n  top: -1em;\n  left: auto;\n  right: -1em;\n  width: 50%;\n\n  @media (--screen-md) {\n    top: 3em;\n    bottom: auto;\n    right: auto;\n  }\n}\n\n.headToToe_annotation2 {\n  position: absolute;\n  bottom: 2em;\n  top: auto;\n  left: auto;\n  right: -1em;\n  width: 50%;\n\n  @media (--screen-md) {\n    left: 0;\n    top: 74%;\n    bottom: auto;\n  }\n}\n\n.realtime_annotation1 {\n  position: absolute;\n  bottom: -2em;\n  top: auto;\n  left: auto;\n  right: -2em;\n  width: 55%;\n\n  @media (--screen-md) {\n    right: 0;\n    left: auto;\n    top: 37%;\n    bottom: auto;\n  }\n}\n\n.outline_annotation1 {\n  position: absolute;\n  top: 4em;\n  bottom: auto;\n  left: auto;\n  right: -1em;\n  width: 55%;\n\n  @media (--screen-md) {\n    right: 0;\n    left: auto;\n    top: 40%;\n  }\n}\n\n.messages_annotation1 {\n  position: absolute;\n  top: -1em;\n  bottom: auto;\n  left: auto;\n  right: 0;\n  width: 70%;\n\n  @media (--screen-sm) {\n    right: -1em;\n  }\n\n  @media (--screen-md) {\n    right: 0;\n    left: auto;\n    top: 12%;\n    bottom: auto;\n  }\n}\n\n.messages_annotation2 {\n  position: absolute;\n  top: auto;\n  bottom: 0;\n  left: auto;\n  right: 0;\n  width: 55%;\n\n  @media (--screen-sm) {\n    right: -1em;\n  }\n\n  @media (--screen-md) {\n    right: 0;\n    left: auto;\n    top: auto;\n    bottom: 12%;\n  }\n}\n\n.spanish_annotation1 {\n  position: absolute;\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 2.5em;\n  width: 60%;\n\n  @media (--screen-sm) {\n    right: -1em;\n  }\n\n  @media (--screen-md) {\n    right: 0;\n    left: auto;\n    top: 41%;\n    bottom: auto;\n  }\n}\n\n.trustStatement {\n  color: white;\n  font-weight: 400;\n  background-image: url(./img/climbers.webp);\n  background-size: cover;\n  background-position: 35% center;\n  padding: var(--section-gap) 0;\n\n  @media (prefers-color-scheme: dark) {\n    background-image: url(./img/climbers-dark.webp);\n    background-position: 35% center;\n  }\n\n  & h2 {\n    line-height: 1.1;\n    margin-bottom: 0.5em;\n  }\n\n  & .trustStatementInner {\n    position: relative;\n    padding: 1.5em 2em;\n    margin: calc(1.5 * var(--section-gap)) auto;\n    max-width: 960px;\n    &::before {\n      display: block;\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: var(--color-blue-4);\n      opacity: 0.6;\n      z-index: -1;\n\n      @media (min-width: 960px) {\n        border-radius: 16px;\n      }\n    }\n\n    @media (min-width: 960px) {\n      padding: 1em 2em;\n    }\n  }\n\n  @media (--screen-sm) {\n    margin-top: 0;\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n/* Carousel 2 */\n\n.guide_annotation1 {\n  position: absolute;\n  top: auto;\n  bottom: 1em;\n  right: -1em;\n  left: auto;\n  width: 70%;\n\n  @media (--screen-md) {\n    left: 0;\n    right: 0;\n    top: 32%;\n    bottom: auto;\n  }\n}\n\n.vitalsHistory_annotation1,\n.guide2_annotation1 {\n  position: absolute;\n  top: -1em;\n  left: auto;\n  right: 0;\n  width: 59%;\n\n  @media (--screen-md) {\n    right: 0;\n    top: 2em;\n    left: auto;\n    bottom: auto;\n  }\n}\n\n.vitalsHistory_annotation2,\n.guide2_annotation2 {\n  position: absolute;\n  right: 0;\n  left: auto;\n  top: auto;\n  bottom: -2em;\n  width: 59%;\n\n  @media (--screen-md) {\n    right: 0;\n    top: auto;\n    bottom: 1em;\n  }\n}\n\n.appToApp_annotation1 {\n  position: absolute;\n  top: auto;\n  bottom: -2em;\n  left: auto;\n  right: 0;\n  width: 80%;\n\n  @media (--screen-md) {\n    left: auto;\n    right: 0;\n    top: 25%;\n    bottom: auto;\n  }\n}\n\n.pdf_annotation1 {\n  position: absolute;\n  top: auto;\n  bottom: -2em;\n  left: auto;\n  right: 0;\n  width: 80%;\n\n  @media (--screen-md) {\n    left: auto;\n    right: 0;\n    top: 55%;\n    bottom: auto;\n  }\n}\n\n/* at the end so that it overrides */\n.annotation {\n  @media (--screen-md) {\n    width: 175%;\n  }\n\n  & a {\n    font-weight: bold;\n    text-decoration: underline !important;\n    text-underline-offset: 0.2em !important;\n  }\n\n  & :global(.wild-card-heading) {\n    @media (--screen-md) {\n      max-width: calc(38% + (490px - 50vh));\n    }\n  }\n\n  & :global(.wild-card-body) > div {\n    @media (--screen-md) {\n      max-width: calc(38% + (490px - 50vh));\n    }\n  }\n}\n\n/* >>>>>>>> END CAROUSELS <<<<<<< */\n\n.lightDarkModeCard {\n  max-width: min(100% - 2 * var(--content-inset), 24em);\n  margin: var(--section-gap) auto;\n  text-align: center;\n  padding-right: 2em;\n\n  & button {\n    margin: 1em 0;\n  }\n}\n\n.link {\n  text-decoration: underline !important;\n  text-underline-offset: 3px;\n}\n\n.nowrap {\n  white-space: nowrap;\n}\n\n.footerNav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.1em;\n  max-width: 100%;\n  flex-wrap: wrap;\n\n  & a {\n    border-right: 1px solid rgba(255, 255, 255, 0.5);\n    border-left: 1px solid rgba(255, 255, 255, 0.5);\n    padding: 0 1em;\n    margin-right: -1px;\n    margin-bottom: 1em;\n  }\n}\n\n/* Desktop hero nav: the site links, tucked into the empty space beneath the\n   description card. Width comes from .hookLeft (40em), NOT from the card,\n   which overflows its column on purpose — so footerNav's flex-wrap gives the\n   two-or-three centred rows this space wants. */\n.heroNav {\n  position: relative;\n  z-index: 1;\n  margin-top: 2.5em;\n  width: 100%;\n  font-size: 1em;\n\n  /* In its old spot at the foot of the hero these links sat on the darkened\n     bottom edge of the photo; here they land on open sky, which is bright in\n     the light-scheme image. A soft shadow keeps them legible against both\n     without changing the treatment. */\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);\n  /* Inherited 200 (Manrope ExtraLight) is too fine to hold up over a photo. */\n  font-weight: 400;\n\n  & a {\n    border-color: rgba(255, 255, 255, 0.65);\n  }\n}\n\n.headerNav {\n  margin-top: 2em;\n  padding: 0 var(--content-inset);\n  position: relative;\n  z-index: 1;\n\n  @media (--screen-lg) {\n    margin-top: calc(-2em);\n  }\n}\n\n.content {\n  & .copyright {\n    color: rgba(255, 255, 255, 0.4);\n    font-size: 0.8em;\n  }\n\n  & footer {\n    padding: 4em;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1em;\n  }\n}\n\n/* Store badges flanking the hero logo on portrait screens — one on each side,\n   vertically centered on the logo. Icons scale with font-size (2.4em in\n   GetTheAppCTA). Hidden in the wide/landscape layout, where the description\n   card's CTA box carries the store links instead. */\n.logoWrapper {\n  position: relative;\n\n  /* In the landscape layout the logo itself is position:absolute and must\n     anchor to the section, not this wrapper — keep the wrapper static there. */\n  @media (--screen-lg) {\n    position: static;\n  }\n}\n\n.heroStores {\n  position: absolute;\n  top: auto;\n  /* align with the bottom of the logo image: the logo carries 1.5em\n     (wrapper-em) bottom margin inside the wrapper → 1.5 / 1.35 local em */\n  bottom: 1.11em;\n  left: 50%;\n  transform: translateX(-50%);\n  /* logo is 13em (wrapper-em) wide; row = logo + ~2.5em breathing per side.\n     Our font-size is 1.35em, so wrapper-18em ≈ 13.4 local em. */\n  width: 15.7em;\n  display: flex;\n  align-items: flex-end;\n  margin: 0;\n  font-size: 1.35em;\n  pointer-events: none;\n\n  & > span {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0;\n\n    & a {\n      pointer-events: auto;\n    }\n  }\n\n  @media (--screen-lg) {\n    display: none;\n  }\n}\n\n/* Translucent hero box housing the store CTA inside the description card. */\n.ctaHeroBox {\n  margin-top: 1em;\n  padding: 1em 1.4em;\n  border-radius: 14px;\n  background: color-mix(in srgb, var(--color-paper-2) 40%, transparent);\n  border: none;\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `YRJZq__layout`;
export var hookSection = `pvJ69__hookSection`;
export var hookWrapper = `mUyOV__hookWrapper`;
export var hookLeft = `cVIDW__hookLeft`;
export var logo = `V9K2g__logo`;
export var headingCard = `FmOa___headingCard`;
export var presents = `GvCTl__presents`;
export var headingCardInner = `TZbwC__headingCardInner`;
export var plus = `H5gQ3__plus`;
export var tagLine = `KEyRr__tagLine`;
export var lead = `KMv17__lead`;
export var hookRight = `w_3pB__hookRight`;
export var hookPhoneWrapper = `cF4D0__hookPhoneWrapper`;
export var phone = `f5w7a__phone`;
export var screenshot = `qguw8__screenshot`;
export var descriptionCard = `g6Lyo__descriptionCard`;
export var cta = `kwmC8__cta`;
export var problemStatementCta = `e6PLB__problemStatementCta`;
export var appName = `GI2ls__appName`;
export var descriptionInner = `xoM7Q__descriptionInner`;
export var content = `xQTux__content`;
export var contentRow = `cSXSV__contentRow`;
export var lifecycleCardRow = `eDm5p__lifecycleCardRow`;
export var lifecycleCard = `udcos__lifecycleCard`;
export var lifecycleRow = `bjtws__lifecycleRow`;
export var lifecycleItem = `kakbq__lifecycleItem`;
export var offlineFirst = `kBNMr__offlineFirst`;
export var scribeSection = `lqSdi__scribeSection`;
export var scribeCopy = `wYmHt__scribeCopy`;
export var scribeBadge = `cT89j__scribeBadge`;
export var scribeEmphasis = `AnkeM__scribeEmphasis`;
export var scribeLink = `aOCkr__scribeLink`;
export var scribeStores = `G4y2h__scribeStores`;
export var scribeStoresLabel = `_1cSHb__scribeStoresLabel`;
export var scribeStoreButtons = `qGP87__scribeStoreButtons`;
export var scribePhoneWrapper = `fz9gH__scribePhoneWrapper`;
export var scribePhone = `BzJHf__scribePhone`;
export var problemStatement = `p1Bql__problemStatement`;
export var carousel = `BbUEP__carousel`;
export var headToToe_annotation1 = `poDAw__headToToe_annotation1`;
export var headToToe_annotation2 = `IBCR3__headToToe_annotation2`;
export var realtime_annotation1 = `rkd_T__realtime_annotation1`;
export var outline_annotation1 = `u16PE__outline_annotation1`;
export var messages_annotation1 = `ILpi3__messages_annotation1`;
export var messages_annotation2 = `LX9v5__messages_annotation2`;
export var spanish_annotation1 = `h_ADd__spanish_annotation1`;
export var trustStatement = `KtIZN__trustStatement`;
export var trustStatementInner = `Au0Ui__trustStatementInner`;
export var guide_annotation1 = `fFu9K__guide_annotation1`;
export var vitalsHistory_annotation1 = `m8YkH__vitalsHistory_annotation1`;
export var guide2_annotation1 = `sZ1Li__guide2_annotation1`;
export var vitalsHistory_annotation2 = `j9zR4__vitalsHistory_annotation2`;
export var guide2_annotation2 = `erAiE__guide2_annotation2`;
export var appToApp_annotation1 = `Jhpy7__appToApp_annotation1`;
export var pdf_annotation1 = `GU64z__pdf_annotation1`;
export var annotation = `JN2c9__annotation`;
export var lightDarkModeCard = `y0I_s__lightDarkModeCard`;
export var link = `cybMS__link`;
export var nowrap = `pkgBz__nowrap`;
export var footerNav = `roE8E__footerNav`;
export var heroNav = `Vs7Od__heroNav`;
export var headerNav = `kx38v__headerNav`;
export var copyright = `tp8ti__copyright`;
export var logoWrapper = `_C1qO__logoWrapper`;
export var heroStores = `gPaS4__heroStores`;
export var ctaHeroBox = `yYi0M__ctaHeroBox`;
export default ___CSS_LOADER_EXPORT___;
